import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCategories, selectCategories, skipCategories } from '../../redux/ApiSlice/CategorySlice'

const UserIntrest = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { allCategories, loading, submitting } = useSelector((state) => state.Category)

    const [selected, setSelected] = useState(new Set())
    const [showWarning, setShowWarning] = useState(false)

    useEffect(() => {
        dispatch(fetchCategories())
    }, [dispatch])

    const toggle = (slug) => {
        setSelected((prev) => {
            if (!prev.has(slug) && prev.size >= 5) {
                setShowWarning(true)
                return prev
            }
            setShowWarning(false)
            const next = new Set(prev)
            next.has(slug) ? next.delete(slug) : next.add(slug)
            return next
        })
    }

    const handleContinue = async () => {
        await dispatch(selectCategories([...selected])).unwrap()
        sessionStorage.removeItem('show_interests')
        navigate('/')
    }

    const handleSkip = async () => {
        await dispatch(skipCategories()).unwrap()
        sessionStorage.removeItem('show_interests')
        navigate('/')
    }

    return (
        <div className="h-full bg-white dark:bg-[#1E1D21] flex flex-col items-center">
            <div className="w-full flex flex-col">
                <div className="sticky top-0 bg-white dark:bg-[#1E1D21] p-3 border-b border-gray-200 dark:border-gray-700">
                    <h1 className="text-[18px] font-bold text-black dark:text-white mb-1">What are you into?</h1>
                    <p className="text-[12px] text-black dark:text-gray-400">
                        Select up to 5 interests to help us build your feed.
                    </p>
                </div>

                <div className="flex flex-col p-3 gap-5">
                    {loading ? (
                        <div className="flex justify-center items-center py-10">
                            <svg className="animate-spin h-6 w-6 text-[#BDE6FF]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                            </svg>
                        </div>
                    ) : (
                        allCategories.map((cat) => (
                            <div key={cat.label}>
                                <p className="text-[14px] font-semibold text-black dark:text-white mb-2">{cat.label}</p>
                                <div className="flex flex-wrap gap-2">
                                    {cat.items.map((item) => {
                                        const active = selected.has(item.slug)
                                        return (
                                            <button
                                                key={item.slug}
                                                onClick={() => toggle(item.slug)}
                                                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-[12px] font-semibold transition-colors
                                                    ${active
                                                        ? 'bg-[#BDE6FF] border-[#a2d9fb] text-black'
                                                        : 'bg-white dark:bg-[#333333] border-gray-200 dark:border-gray-700 text-gray-800 dark:text-gray-400 hover:border-gray-400 dark:hover:border-gray-600'
                                                    }`}
                                            >
                                                <span>{item.emoji}</span>
                                                <span>{item.name}</span>
                                            </button>
                                        )
                                    })}
                                </div>
                            </div>
                        ))
                    )}
                </div>

                <div className="sticky bottom-0 bg-white dark:bg-[#1E1D21] p-3 border-t border-gray-200 dark:border-gray-700">
                    <p className="text-center text-[12px] pb-1 text-gray-400 dark:text-gray-400">
                        {selected.size} / 5 selected
                    </p>
                    {showWarning && (
                        <p className="text-center text-[12px] pb-2 text-red-500">
                            You can only select up to 5 interests.
                        </p>
                    )}

                    <button
                        onClick={handleContinue}
                        disabled={selected.size === 0 || submitting}
                        className={`w-full py-3 rounded-xl text-[14px] font-semibold transition-colors flex items-center justify-center gap-2
                        ${selected.size > 0 && !submitting
                                ? 'bg-[#BDE6FF] text-black hover:bg-[#a2d9fb]'
                                : 'bg-gray-200 dark:bg-[#333333] text-gray-400 cursor-not-allowed'
                            }`}
                    >
                        {submitting ? (
                            <svg className="animate-spin h-4 w-4 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                            </svg>
                        ) : 'Continue'}
                    </button>

                    <button
                        onClick={handleSkip}
                        className="mt-4 text-[14px] text-gray-600 dark:text-gray-600 font-semibold hover:underline text-center cursor-pointer"
                    >
                        Skip for now
                    </button>
                </div>
            </div>
        </div>
    )
}

export default UserIntrest
